<script>
	import { postUserInfo, sleep } from '$lib/utils.js';
	import { Platform, IsElectron, UserInfo, UserEmail, IsDev, DateRange } from '$lib/store.js';
	import { Capacitor } from '@capacitor/core';
	import { goto } from '$app/navigation';
	import OnboardPage from '../../../../components/OnboardPage.svelte';
	import Controls from '../../../../components/Controls.svelte';

	import { onMount } from 'svelte';
	onMount(() => {
		$IsElectron ? window.api?.call('onboarding').catch((e) => '') : '';
	});
	let selected = 2;
	let booked;
	$: content = {
		title: `Book a call`,
		text: [
			'The people who get the biggest boost from using Magicflow are the people we show around the product.',
			'The whole call takes just 15 minutes - we recommend booking for sometime this week. Excited to chat!'
		],
		contentSlot: true,
		slot: true,
		// img: 'TrackScreen.webp',

		img: 'preview.webp',
		button: {
			function: async () => {
				booked = true;
				setTimeout(() => ($UserInfo.onboardingComplete = true), 4000);
				goto('/onboard/subscribe');
			},
			text: 'Book a call',
			props: { 'data-cal-link': 'michaeljelly/15min' },
			skip: '/onboard/subscribe'
		}
	};
</script>

<OnboardPage {content} {selected}>
	<div slot="content" class="flex-grow h-full flex flex-col">
		<!-- Cal inline embed code begins -->
		<!-- <div style="width:100%;height:100%;overflow:scroll" id="my-cal-inline" /> -->
		<!-- Cal inline embed code ends -->
		<div class="flex mt-auto items-center gap-4">
			<img
				class="rounded-2xl shadow-md mt-auto w-48"
				src="https://uploads-ssl.webflow.com/5e2da1d25b8bed633cb12288/63496353b7be8f2a56280aef_Screenshot%202022-09-16%20at%2014.15.02.webp"
				alt="Mike's face"
			/>
			<div class="flex-grow">
				<h4 class="font-bold">You'll be chatting with Mike</h4>
				<p class="text-sm opacity-90">
					He'll show you how to get the most out of Magicflow and answer any questions you have.
				</p>
			</div>
		</div>
	</div>
	<div slot="showcase">
		<iframe
			width="560"
			height="315"
			src="https://www.youtube-nocookie.com/embed/_9dTD5qh_8Y"
			title="YouTube video player"
			frameborder="0"
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
			allowfullscreen
		/>
	</div>
</OnboardPage>
